import React from 'react';

const SecResearchIntro = ({ styles }) => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroBox}>
        <h1 className={styles.heroTitle}>AI 시대 보안관리와 보안 자동화 융합 연구개발</h1>
      </div>
    </section>
  )
}

export default SecResearchIntro